    
import React from "react";

function Checkbox(props) {
  return (
    <div className="custom-control custom-checkbox">
        <input type="checkbox" className="custom-control-input" name={props.name} id={props.id} 
        value={props.value} defaultChecked={props.checked} onChange={props.onChange}></input>
        <label className="custom-control-label" htmlFor={props.id}>{props.children}</label>
    </div>
  );
}

export default Checkbox;